module.exports = __webpack_public_path__ + "img/redeem-rewards.22638fdc.png";